import { useEffect, useState } from "react";
import i18next from "i18next";
import MagexLogo from "../../Icons/Magex_logo.png";
import { useNavigate } from "react-router-dom";
import request from "../../../../services/Request";
import { useTranslation } from "react-i18next";
import { rearrangeBasedOnFirstArray } from "../../../../services/methods";
import Swal from "sweetalert2";
import { useAuth } from "../../../items/AuthProvider";

const getMachineURLR = `${process.env.REACT_APP_SERVER_API}/machines/edit/`;
const getPromoURLR = `${process.env.REACT_APP_SERVER_API}/promos/machine/ClientUser/`;
const getAllProdURLR = `${process.env.REACT_APP_SERVER_API}/machines/getMachineUIproduct/ClientUser/`;
const getAllCateURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredCategroy/ClientUser/`;
const getAllBrandURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredBrand/ClientUser/`;

function Initial(props) {
  const { refresh, setRefresh } = useAuth();
  useEffect(() => {
    setRefresh(!refresh);
  }, []);
  // console.log(
  //   "getBrandsgetBrandsgetBrandsgetBrandsgetBrandsgetBrandsgetBrandsgetBrands"
  // );
  const { t } = useTranslation();
  const { stat, setStat, setThemeColor } = props;
  const [info, setInfo] = useState(null);
  const [initText, setInitText] = useState("");
  const history = useNavigate();
  const machineID = localStorage.getItem("machineID");
  console.log("machineID", machineID);

  let outofStock = false;
  let items = [];
  let filteredProducts = [];
  let categoryArray = [];
  let language = "en";

  useEffect(() => {
    props.setShowCart(false);
    props.cleanUp();
    let myMachineObj = null;
    localStorage.removeItem("MagexApp.cart");
    localStorage.removeItem("promo");
    localStorage.removeItem("codePromo");
    localStorage.removeItem("oneTime");
    localStorage.removeItem("machine");
    localStorage.removeItem("products");
    localStorage.removeItem("category");
    localStorage.removeItem("brand");

    const voidMachine = (res, setDefaultLogo) => {
      // console.log("machinemachinemachine", res);
      let promise = new Promise((resolve, reject) => {
        try {
          const style = document.createElement("style");
          document.head.appendChild(style);
          setThemeColor(res.data.themeColor);
          if (res.data.themeColor) {
            if (res.data.themeColor.text) {
              document.body.style.setProperty(
                "--text-color",
                res.data.themeColor.text
              );
            }
            if (res.data.themeColor.highlight_color) {
              document.body.style.setProperty(
                "--highlight-color",
                res.data.themeColor.highlight_color
              );
            }
            if (res.data.themeColor.cart_color) {
              document.body.style.setProperty(
                "--cart-color",
                res.data.themeColor.cart_color
              );
            }
            if (res.data.themeColor.theme) {
              document.body.style.setProperty(
                "--theme-color",
                res.data.themeColor.theme
              );
            }
            if (res.data.themeColor.price) {
              document.body.style.setProperty(
                "--price-color",
                res.data.themeColor.price
              );
            }
            if (res.data.themeColor.plus) {
              document.body.style.setProperty(
                "--plus-color",
                res.data.themeColor.plus
              );
            }
            if (res.data.themeColor.minus) {
              document.body.style.setProperty(
                "--minus-color",
                res.data.themeColor.minus
              );
            }
            if (res.data.themeColor.soldout) {
              document.body.style.setProperty(
                "--soldout-color",
                res.data.themeColor.soldout
              );
            }
            if (res.data.themeColor.soldout_text) {
              document.body.style.setProperty(
                "--soldout-text",
                res.data.themeColor.soldout_text
              );
            }
            if (res.data.themeColor.navibar) {
              document.body.style.setProperty(
                "--navi-color",
                res.data.themeColor.navibar
              );
            }
            if (res.data.themeColor.button) {
              document.body.style.setProperty(
                "--buttons-color",
                res.data.themeColor.button
              );
            }
            if (res.data.themeColor.product_text) {
              document.body.style.setProperty(
                "--product-text",
                res.data.themeColor.product_text
              );
            }
            if (res.data.themeColor.background)
              document.body.style.setProperty(
                "--background-color",
                res.data.themeColor.background
              );
            if (res.data.themeColor.secondary)
              document.body.style.setProperty(
                "--container-color",
                res.data.themeColor.secondary
              );
            // if (res.data.themeColor.search_form)
            //   document.body.style.setProperty(
            //     '--search-form-color',
            //     res.data.themeColor.search_form
            //   );
            if (res.data.themeColor.backgroundImage) {
              const bgURL = `
      .main-container {
          background-color: white;
          background-attachment: fixed;
          background-image: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.backgroundImage}/${res.data.belongTo});
      }
      `;
              style.sheet.insertRule(bgURL);
            }
            if (res.data.themeColor.logo) {
              const logoURL = `
            .home-logo {
                content: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.logo}/${res.data.belongTo})
            }
            `;
              // document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
              style.sheet.insertRule(logoURL);
            } else {
              style.sheet.insertRule(`
          .home-logo {
              content: url(${MagexLogo})
          }
          `);
            }
          }
          //set primary language
          i18next.changeLanguage(res.data.languages[0].code);
          props.setlangs(res.data.languages[0].code);
          language = res.data.languages[0].code;
          localStorage.setItem("machine", JSON.stringify(res.data));
          myMachineObj = res.data;
          props.setMachine("settingMachine", res.data);
          //init Text
          if (res.data.themeColor.initText) {
            setInitText(res.data.themeColor.initText);
          } else {
            setInitText(t(`Initializing...`));
          }

          resolve("done");
        } catch (e) {
          console.log(e);
          Swal.fire({
            text: "Something went wrong" + e,
          });
          // history("/");
        }
      });

      promise.then();
    };

    const voidProd = async (res) => {
      let copy = [...res.data];
      let products = res.data;

      console.log("copycopycopy", copy);
      //filter hided products
      const hideProducts = myMachineObj.products_hide;
      hideProducts.forEach((hide) => {
        let hideIndex = products.findIndex((e) => hide == e._id);
        if (hideIndex > -1) {
          products.splice(hideIndex, 1);
        }
      });

      const bestMachineArray = myMachineObj.products_bs;
      let bestSeller = [];
      copy.forEach((item, i) => {
        //preview set curernt stock to 4
        item.current_max = item.current_stock;
        item.idx = i;
        if (!item.name.es) {
          item.name.es = "";
        }
        if (!item.name.fr) {
          item.name.fr = "";
        }
      });

      if (bestMachineArray?.length > 0) {
        if (myMachineObj?.themeColor?.sp_column === "1") {
          copy = rearrangeBasedOnFirstArray(bestMachineArray, copy);
          console.log("goes in DEV MODEDDD after arrange", copy);
        }

        bestMachineArray?.forEach((bsProd) => {
          let index = copy.findIndex((e) => e._id == bsProd);
          if (index > -1) {
            bestSeller.push(copy[index]);
          }
        });
      } else {
        bestSeller = [...copy];
      }
      localStorage.setItem("bestSeller", JSON.stringify(bestSeller));
      console.log("bestSellerbestSellerbestSeller", bestSeller);
      try {
        const codePromo = JSON.parse(localStorage.getItem("promo"));
        // console.log(codePromo);
        //  console.log(codePromo)
        if (codePromo.length > 0) {
          codePromo.forEach((item) => {
            if (item.promoType === "buyXProducts") {
              if (item.cateOrProd === "cate") {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].buyX = item.productsToBuy;
                        products[j].percentage = item.percentage;
                        products[j].discount = item.amount;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === "prod") {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = item.productsToBuy;
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority more
                        products[j].prodPromo = true;
                        console.log("11");
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === "All Products") {
                products.forEach((product) => {
                  product.promo = item._id;
                  product.promoType = item.promoType;
                  product.percentage = item.percentage;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice =
                    Math.round(product.discountedPrice * 100) / 100;
                  product.discount = item.amount;
                  product.buyX = item.productsToBuy;
                  product.percentage = item.percentage;
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            } else if (
              item.promoType === "general" ||
              item.promoType === "emailCode"
            ) {
              if (item.cateOrProd === "cate") {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        if (item.promoType === "emailCode") {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === "prod") {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        if (item.promoType === "emailCode") {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority
                        products[j].prodPromo = true;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === "All Products") {
                products.forEach((product) => {
                  if (item.promoType === "emailCode") {
                    product.emailCode = true;
                  }
                  product.promo = item._id;
                  product.promoType = item.promoType;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice =
                    Math.round(product.discountedPrice * 100) / 100;
                  product.buyX = 0;
                  product.discount = item.amount;
                  product.percentage = item.percentage;
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            }
          });
        }
        // initial products state

        props.setProds(copy);
      } catch (e) {
        console.log(e);
        // history("/");
      }
    };

    const getMachine = async () => {
      const setDefaultLogo = (style) => {
        document.querySelector(".homeImg").style.content = `url(${MagexLogo})`;
        style.sheet.insertRule(`
                .home-logo {
                    content: url(${MagexLogo})
                }
            `);
      };

      await request({
        method: "get",
        url: getMachineURLR + machineID,
      })
        .then((res) => {
          voidMachine(res, setDefaultLogo);
        })
        .catch((err) => {});
    };

    const getPromo = async () => {
      await request({
        method: "get",
        url: getPromoURLR + machineID,
      })
        .then((res) => {
          localStorage.setItem("promo", JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    };

    async function getCates() {
      await request({
        method: "get",
        url: getAllCateURLR + machineID,
      })
        .then((res) => {
          categoryArray = res.data[0];
          localStorage.setItem("category", JSON.stringify(res.data[0]));
        })
        .catch((err) => {});
    }

    async function getBrands() {
      await request({
        method: "get",
        url: getAllBrandURLR + machineID,
      })
        .then((res) => {
          localStorage.setItem("brand", JSON.stringify(res.data[0]));
        })
        .catch((err) => {
          console.log(err);
        });
    }

    async function getProds() {
      await request({
        method: "get",
        url: getAllProdURLR + machineID,
      })
        .then(async (res) => {
          console.log("remoteProduct", res.data);
          voidProd(res);
        })
        .catch((err) => {});
    }

    let run = async function () {
      await getPromo();
      await getMachine();
      await getProds();
      await getCates();
      await getBrands();
    };
    const nextPage = () => {
      // return;
      try {
        //go to screensaver linked page directly instead of home page
        console.log("filteredProducts", filteredProducts);
        console.log("categoryArray", categoryArray);

        if (
          myMachineObj?.themeColor?.c_column === "0" &&
          myMachineObj?.themeColor?.b_column === "0"
        ) {
          console.log(
            "setHomesetHomesetHomesetHomesetHomesetHomesetHomesetHomesetHome"
          );
          localStorage.setItem("homepage", `/machineUI/category/cate/all/all`);
        } else {
          localStorage.setItem("homepage", `/machineUI/homePage`);
        }

        let found = false;

        if (!found) {
          const homepage = localStorage.getItem("homepage");
          history(homepage);
        }
      } catch (err) {
        console.log("someerror", err);
        setInfo(JSON.stringify(err));
      }
    };

    if (!outofStock) {
      run().then((e) => {
        if (myMachineObj) {
          nextPage();
        } else {
          setInfo(`No Data found`);
        }
      });
    }

    return () => {};
  }, []);

  return (
    <div className="main-container flex-column d-flex justify-content-center align-items-center mt-5">
      <div className="init-div">{initText}</div>
      <div className="init-div">{info}</div>
    </div>
  );
}
export default Initial;
